const appData = {
  "appDomain": "http://0.0.0.0:3000",
  "appUrl": "http://0.0.0.0:3000",
  "publicUrl": "http://0.0.0.0:3000",
  "publicRoutePath": "http://0.0.0.0:3000",
  "gseoClient": "alblaster-jobs",
  "gseoRecaptcha": "6LfSxMMaAAAAAGziyyYOEc7MosJoqW8j0nj2j0dP",
  "analyticsUA": "UA-105310868-2",
  "ga4_id": "xxx",
  "tag_manager_id": "",
  "meta_pixel_id": ""
};
export {appData};
